import { Injectable } from '@angular/core';
import { UtilsService } from '../utils/utils.service';
import { environment } from 'src/environments/environment';
import { URLS_CONST } from 'src/app/shared/constants/url-constants';


@Injectable({
  providedIn: 'root'
})
export class VerbatimService {

  constructor(public _utilsService: UtilsService) { }

  getFeeds(idDetails) {
    const url = this._utilsService.apiUrlGeneration(environment.webPrivateV1, environment.webPrivateV1.getVerbatimFeeds);
    return this._utilsService.postAPICall(url, idDetails,this._utilsService.setHeaders())
  }
  getListForSentTab(reqParams: any){
    const url = this._utilsService.apiUrlGeneration(environment.webPrivateV1, '/get_rating_request_status');
    return this._utilsService.getAPICall(url, this._utilsService.setHeaderWithParams(reqParams))
  }
  getUserDetailsByType(reqParams: any){
    const url = this._utilsService.apiUrlGeneration(environment.webPrivateV1, '/search/users');
    return this._utilsService.getAPICall(url, this._utilsService.setHeaderWithParams(reqParams))
  }
  getRelationshipDetailByUserId(reqParams: any){
    const url = this._utilsService.apiUrlGeneration(environment.webPrivateV1, '/feeds/relationship');
    return this._utilsService.getAPICall(url, this._utilsService.setHeaderWithParams(reqParams))
  }

  getRequestByAdhocEventId(reqParams: any){
    const url = this._utilsService.apiUrlGeneration(environment.webPrivateV1, environment.webPrivateV1.feedbackRequestByAdhocEventId);
    return this._utilsService.getAPICall(url, this._utilsService.setHeaderWithParams(reqParams))
  }

  onDemandDispatch(body: any) {
    const url = this._utilsService.apiUrlGeneration(environment.webPrivateV1, environment.webPrivateV1.onDemandDispatch);
    return this._utilsService.postAPICall(url, body, this._utilsService.setHeaders());
  }

  getCustomerNotifierConfiguration(brandId: string) {
    const url = this._utilsService.apiUrlGeneration(environment.webPrivateV1, environment.webPrivateV1.customerNotifierConfiguration);
    return this._utilsService.getAPICall(url, this._utilsService.setHeaderWithParams({ id: brandId }));
  }

  getConversationVersionList(reqParams: any){
    const url = this._utilsService.apiUrlGeneration(environment.webPrivateV1, '/configs/configuration_list');
    return this._utilsService.getAPICall(url, this._utilsService.setHeaderWithParams(reqParams))
  }
  getConversationDetailedByVersion(reqParams: any){
    const url = this._utilsService.apiUrlGeneration(environment.webPrivateV1, '/configs/configuration');
    return this._utilsService.getAPICall(url, this._utilsService.setHeaderWithParams(reqParams))
  }
  postConversationConfig(config) {
    const url = this._utilsService.apiUrlGeneration(environment.webPrivateV1, '/brands/configuration');
    return this._utilsService.postAPICall(url, config,this._utilsService.setHeaders())
  }
  
}
